module.exports = __webpack_public_path__ + "img/20190528162607034.35d91ced.png";